import React, { Component } from 'react';
import { Button, Card, CardText, CardTitle, DatePicker, Grid, Autocomplete, SelectField } from 'react-md';
import Api from '../../common/api';

import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import { openSnackbar } from '../../components/message';

import Highcharts from 'highcharts';
import HC_map from 'highcharts/modules/map'
import HighchartsReact from 'highcharts-react-official';

HC_map(Highcharts)

const TODAY = new Date();

export default class GraficoMaiorSaida extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            comprador: {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            },
            id_estado: "",
            nome_comprador: "",
            sugestoes: [],
            estados: [],
            data: {
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: true,
                },
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                colors: ["#1de9b6", "#4fc3f7", "#26c6da", "#7b1fa2", "#d81b60", 
                    "#ff3d00", "#455a64", "#aed581", "#ffca28", "#3949ab"],
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                            style: {
                                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                            }
                        }
                    }
                }
            },
            data_inicial: "",
            data_final: "",
            todosEstados: {
                id: null,
                nome: "Todos",
                sigla: ""
            }
        }
    }

    componentDidMount() {
        this.setFilterInitialDate();
        this.getAllEstados();
    }

    render() {
        const { data, title, nome_comprador, sugestoes, estados } = this.state;

        return (
            <Grid>
                <Breadcrumb title="Gráfico" url="/grafico-maior-saido"/>
                <Card className="md-cell md-cell--12 tw-card">
                    <CardTitle title="Filtro"/>
                    <CardText>
                        <form onSubmit={this.getChartData}>
                            <div className="md-grid">
                                <DatePicker id="data_inicial" label="Selecione a data inicial"
                                    autoOk className="md-cell md-cell--bottom" defaultValue={new Date(TODAY.getFullYear(), TODAY.getMonth(), 1)} 
                                    onChange={this.handleChangeData('data_inicial')} />
                                
                                <DatePicker id="data_final" label="Selecione a data final"
                                    autoOk className="md-cell md-cell--bottom" defaultValue={TODAY}
                                    onChange={this.handleChangeData('data_final')} />

                                <Autocomplete id="nome" label="Cliente" data={sugestoes} filter={null} onChange={this.onSearchAutocomplete}
                                    clearOnAutocomplete simplifiedMenu={false} onAutocomplete={this.handleAutocomplete} dataLabel={"nome"}
                                    sameWidth={false} value={nome_comprador} className="md-cell md-cell--bottom" dataValue="id"/>
                            </div>
                            <div className="buttons__group">
                                <div className="left-group">
                                    <SelectField style={{margin:"0"}} id="endereco-estado" placeholder="Pesquisar por Estado" 
                                        menuItems={estados} simplifiedMenu={true} 
                                        onChange={this.handleChangeEstado} itemLabel="nome" itemValue="id"/>
                                </div>
                                <div style={{margin:"0 30% 0 0"}} className="right-group">
                                    <Button type="submit" raised primary >Consultar</Button>
                                </div>
                            </div>
                        </form>
                    </CardText>
                </Card>
                { data.series ? 
                    <Card id="relatorio-pedidos" tableCard className="md-cell md-cell--12 tw-card">                        
                        <CardTitle title={title}/>
                        <HighchartsReact 
                            highcharts={Highcharts} 
                            options={data}
                            allowChartUpdate={true}
                            updateArgs={[true, true, true]}
                        />
                    </Card>
                : null }
                <Message />
            </Grid>
        );
    }

    handleChangeData = name => value => {
        this.setState({ [name]: value });
    }

    onSearchAutocomplete = value => {
        this.setState({nome_comprador: value});
        if(value.length === 0){
            let comprador = {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            }
            this.setState({comprador});
        }
        if(value.length < 3) return;
        Api.getAllCompradores(value)
        .then(response => response.json())
        .then(sugestoes => this.setState({sugestoes}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleAutocomplete = (value, index, matches) => {
        let comprador = matches[index];
        let nome_comprador = comprador.nome;
        this.setState({ comprador, nome_comprador });
    };

    getAllEstados = event => {
        setTimeout(() => {
            Api.getAllStates()
            .then(response => response.json())
            .then(estados => this.setState({estados: this.getTodosEstados(estados)}))
            .catch(error => openSnackbar({ message: error }));
        });
    }

    getTodosEstados = estados => {
        estados.unshift(this.state.todosEstados)
        return estados;
    }

    handleChangeEstado = value => { 
        this.setState({id_estado: value});
    }

    getChartData = event => {
        event.preventDefault();
        Api.getGraficoMaiorSaida(this.state.data_inicial, this.state.data_final, this.state.comprador.id, this.state.id_estado)
        .then(response => response.json())
        .then(chartData => {
            let data = this.state.data;
            let title = chartData.titulo;
            data.series = chartData.series;
            this.setState({ data, title })
        })
        .catch(error => openSnackbar({ message: error }));
    }

    setFilterInitialDate = () => {
        let data_inicial = new Date(TODAY.getFullYear(), TODAY.getMonth(), 1);
        let data_final = TODAY;
        this.setState({
            data_inicial: data_inicial.toLocaleDateString(), 
            data_final: data_final.toLocaleDateString()
        });
    }

}



// WEBPACK FOOTER //
// ./src/views/grafico-maior-saida/GraficoMaiorSaida.js